import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { formatNumber } from '../../../utils/helpers';
import Icon from '../../Icon';

const TextField = ({
  stat,
  name,
  icon,
  value,
  format,
  onClick,
  disabled = false,
  inputMode = 'text',
  maxLength,
  placeholder
}) => {
  const handleKeyDown = e => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    if (
      inputMode === 'numeric' &&
      !/[0-9]/.test(e.key) &&
      e.key !== 'Backspace'
    ) {
      e.preventDefault();
    }
  };

  return (
    <div className="text-field__container">
      {/* eslint-disable */}
      <div
        data-stat={stat}
        onClick={onClick}
        className="text-field"
      >
        {value && <div className="text-field__label">{placeholder}</div>}
        <Field
          name={name}
          value={value}
          format={format}
          component="input"
          autoComplete="off"
          disabled={disabled}
          maxLength={maxLength}
          inputMode={inputMode}
          placeholder={placeholder}
          onKeyDown={handleKeyDown}
          className="text-field__input"
          pattern={inputMode === 'numeric' ? '[0-9]*' : null}
          parse={inputMode === 'numeric' ? formatNumber : v => v}
        />
      </div>
      {/* eslint-enable */}
      {icon && (
        <Icon IconComponent={icon} width={35} height={35} indent={false} />
      )}
    </div>
  );
};

TextField.propTypes = {
  icon: PropTypes.func,
  stat: PropTypes.string,
  format: PropTypes.func,
  onClick: PropTypes.func,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  inputMode: PropTypes.string,
  maxLength: PropTypes.string,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired
};

export default TextField;
